import { PetNamesPage } from '@web/components/pet-names-page';
import { PetNamesScreenProps } from 'shared/screens/pet-names';
import { withServerProps } from '@web/library/with-server-props';

export default function CatNames(props: PetNamesScreenProps) {
  return <PetNamesPage {...props} animal={'cat'} />;
}

export const getServerSideProps = withServerProps();
